import JSZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'

const zip = new JSZip()

export function downloadZipFile(fileName, urls, setLoading, setError) {
  let count = 0
  const zipFilename = `${fileName}`
  setLoading(true)

  urls.forEach(obj => {
    // loading a file and add it in a zip file
    JSZipUtils.getBinaryContent(obj.downloadUrl, function(err, data) {
      if (err) {
        setError(err)
        throw err // or handle the error
      }
      const fileName = `${obj.pseudonym} (${obj.id})/${obj.fileName}`
      zip.file(fileName, data, { binary: true, createFolders: true })

      count++

      if (count === urls.length) {
        zip.generateAsync({ type: 'blob' }).then(function(content) {
          saveAs(content, zipFilename)
          setLoading(false)
        })
      }
    })
  })
}

export function downloadTextFile(fileName, content) {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  saveAs(blob, fileName)
}

export function downloadTextFiles(zipFileName, files, setLoading) {
  const zip = new JSZip()
  setLoading(true)

  files.forEach(file => {
    zip.file(file.path, file.content)
  })

  zip.generateAsync({ type: 'blob' }).then(content => {
    saveAs(content, zipFileName)
    setLoading(false)
  })
}
